import { MeasurementSystem } from '../types/MeasurementSystem';
import { MetricConverter, PerUnitLengthMetricConverter } from './helpers';

const ResistanceUnits = ['ohm', 'kohm', 'mohm'] as const;
export type TResistanceUnit = (typeof ResistanceUnits)[number];

class ResistanceConverter extends MetricConverter<TResistanceUnit, 'ohm'> {
    baseUnit = 'ohm' as const;
    units = ResistanceUnits;
}

export const resistanceConverter = new ResistanceConverter();

const ResistancePerUnitLengthMetricUnits = ['ohm/m', 'ohm/km', 'mohm/m', 'mohm/km'] as const;
type TResistancePerUnitLengthMetricUnit = (typeof ResistancePerUnitLengthMetricUnits)[number];

const ResistancePerUnitLengthImperialUnits = ['ohm/ft', 'mohm/ft'] as const;
type TResistancePerUnitLengthImperialUnit = (typeof ResistancePerUnitLengthImperialUnits)[number];

export const ResistancePerUnitLengthUnits = [
    ...ResistancePerUnitLengthMetricUnits,
    ...ResistancePerUnitLengthImperialUnits,
] as const;
type TResistancePerUnitLengthUnit = (typeof ResistancePerUnitLengthUnits)[number];

type ResistancePerUnitLengthUnitForSystem<MSystem extends MeasurementSystem> = MSystem extends MeasurementSystem.METRIC
    ? TResistancePerUnitLengthMetricUnit
    : MSystem extends MeasurementSystem.IMPERIAL
      ? TResistancePerUnitLengthImperialUnit
      : never;

export class ResistancePerUnitLengthConverter<MSystem extends MeasurementSystem> extends PerUnitLengthMetricConverter<
    TResistancePerUnitLengthUnit,
    'ohm/m'
> {
    baseUnit = 'ohm/m' as const;
    units = ResistancePerUnitLengthUnits;
    system: MSystem;

    constructor(measurementSystem: MSystem) {
        super();

        this.system = measurementSystem;
    }

    getDisplayUnits(): ResistancePerUnitLengthUnitForSystem<MSystem>[] {
        switch (this.system) {
            case MeasurementSystem.METRIC:
                return [...ResistancePerUnitLengthMetricUnits] as ResistancePerUnitLengthUnitForSystem<MSystem>[];
            case MeasurementSystem.IMPERIAL:
                return [...ResistancePerUnitLengthImperialUnits] as ResistancePerUnitLengthUnitForSystem<MSystem>[];

            default:
                throw new Error('Invalid measurement system');
        }
    }
}
